import { render } from "./PatientSamplesTab.vue?vue&type=template&id=d4612194"
import script from "./PatientSamplesTab.vue?vue&type=script&lang=js"
export * from "./PatientSamplesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__